<template>
	<div id="upgrade" v-loading='loading' class='gcardfr'>
		<el-row :gutter="20" class=''>
			<el-col :span='6'>
				<div class="glineflex">
					<label class="glinelb">{{ $t('app_select_sn') }}：</label>
					<el-input @keyup.enter.native="indexget" v-model='usn' size='small' :placeholder="$t('app_sn_pla')"></el-input>
				</div>
			</el-col>
			<el-col :span='6'>
				<div class="glineflex">
					<label class="glinelb">{{ $t('app_select_name') }}：</label>
					<el-input @keyup.enter.native="indexget" v-model='uid' size='small' :placeholder="$t('app_task_pla')"></el-input>
				</div>
			</el-col>
			<el-col :span='6'>
				<div class="glineflex">
					<label class="glinelb">{{ $t('terminal.app_distributor') }}：</label>
					<Merchant :config='sortMc'></Merchant>
				</div>
			</el-col>
		</el-row>
		<br />
		<el-row>
			<el-col :span="24">
				<el-button size='small' type="primary" icon="el-icon-plus" @click='addUg'>{{ $t('app_add_task') }}</el-button>
				<el-button size='small' type="primary" icon="el-icon-plus" @click='addUg1'>{{ $t('app_bottom_pack') }}</el-button>
				<!-- <el-button @click='batchDel' :disabled="sRows.length == 0" size='small' type='danger' plain>批量删除</el-button>     -->
			</el-col>
		</el-row>
		<!-- @selection-change="batchSelected"  -->
		<el-table ref="multipleTable" class='gtbtop' @row-click='rowClick' tooltip-effect="dark" :data="tableData"
			style="width: 100%">
			<!-- <el-table-column
        type="selection"
        width="55">
      </el-table-column> -->
			<el-table-column prop="name" :label="$t('app_task_name')" width="">
			</el-table-column>
			<el-table-column prop="info" :label="$t('app_task_statement')" width="">
			</el-table-column>
			<el-table-column prop="gprssysver" :label="$t('app_bottom_bag')" width="">
			</el-table-column>
			<el-table-column prop="needhwver" width='120' :label="$t('terminal.wifi_version')">
			</el-table-column>
			<el-table-column prop="needgprsextver" width='120' :label="$t('terminal.GPRS_firmware_version')">
			</el-table-column>
			<el-table-column prop="needusraudiover" width="120" :label="$t('terminal.user_audio_version')">
			</el-table-column>
			<el-table-column prop="vercondition" :label="$t('app_upgrade_conditions')" :formatter="setCondition" width="">
			</el-table-column>
			<el-table-column prop="upgradeType" :label="$t('terminal.hardware_version')" fformatter="setUpEuipType" width="">
			</el-table-column>
			
			<el-table-column prop="deviceNum" :label="$t('merchant.equipment_quantity')" width="">
			</el-table-column>
			<el-table-column prop="createTime" :label="$t('app_add_time')" width="170">
			</el-table-column>
			<el-table-column prop="name" :label="$t('app_operation')" width="220">
				<template slot-scope="scope">
					<el-button type='text' @click='toDetail(scope.row)'>{{ $t('app_detail') }}</el-button>
					<el-button type='text' @click='addTer(scope.row)'>{{ $t('terminal.add_device') }}</el-button>
					<el-button :disabled="!scope.row.flag" type='text' @click='editRow(scope.row)'>{{ $t('app_edit') }}</el-button>
					<label class='opbline'>|</label>
					<el-button @click='delRow(scope.row.id)' type='text' class='opdcolor'>{{ $t('app_delete') }}</el-button>
				</template>
			</el-table-column>
		</el-table>

		<Pages class='gpages' :cpage='page' :ctotal="total" :config='pconfig'></Pages> 

		<el-dialog @close="closeDia" class='gstdia' :title="isEdit? $t('app_edit_task'):isdb? $t('app_bottom_pack'):$t('app_add_task')" :visible.sync="showDia">
			<el-form :model="uform" :rules="rules" ref="ruleForm">
				<el-form-item :label="$t('app_task_name')" :label-width="$formlbWidth" prop='name'>
					<el-input v-model="uform.name" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('app_task_statement')" :label-width="$formlbWidth" prop='state'>
					<el-input v-model="uform.state" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('terminal.app_distributor')" :label-width="$formlbWidth" prop='state'>
					<Merchant :config='addMc'></Merchant>
				</el-form-item>
				<el-form-item v-if='(uform.nwtype == 1 ||uform.nwtype == 2 || uform.nwtype == 3 || uform.nwtype == 5) && !isdb' :label="$t('terminal.wifi_version')" :label-width="$formlbWidth" prop=''>
					<el-input v-model="uform.hver" :placeholder="$t('app_wifi_pla')" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item v-if='(uform.nwtype == 1 ||uform.nwtype == 2 || uform.nwtype == 3 || uform.nwtype == 5) && !isdb' :label="$t('app_wifi_version')" :label-width="$formlbWidth" prop=''>
					<el-input v-model="uform.latWifiVerion" :placeholder="$t('app_wifi_pla_2')"  autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item v-if='(uform.nwtype == 2 || uform.nwtype == 3 || uform.nwtype == 4) && !isdb' :label="$t('app_gprs_version')"
					:label-width="$formlbWidth" prop=''>
					<el-input v-model="uform.gver1" :placeholder="$t('app_gprs_pla')" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item v-if='(uform.nwtype == 2 || uform.nwtype == 3 || uform.nwtype == 4) && !isdb' :label="$t('app_gprs_version_2')"
					:label-width="$formlbWidth" prop=''>
					<el-input v-model="uform.latGprsVerion" :placeholder="$t('app_gprs_pla_2')" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item v-if='!isdb' :label="$t('app_audio_version')" :label-width="$formlbWidth" prop=''>
					<el-input v-model="uform.aver" :placeholder="$t('app_audio_pla')" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item v-if='isdb' :label="$t('app_bottom_bag')" :label-width="$formlbWidth" prop='dbver'>
					<el-input v-model="uform.dbver" placeholder="" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item v-if='!isdb' :label="$t('terminal.network_type')" :label-width="$formlbWidth" prop='nwtype'>
					<el-radio v-for="item in $nwtypes" :key="item.vl" v-model="uform.nwtype" :label="item.vl">
						{{item.lb}}</el-radio>
				</el-form-item>
				<el-form-item :label="$t('terminal.hardware_version')" :label-width="$formlbWidth" prop='eqtype'>
					<el-radio @change="rdchange" v-for="item in $hwver" :key="item" v-model="uform.eqtype"
						:label="item">{{item}}</el-radio>
					<br />
					<el-radio @change="rdchange" v-model="uform.eqtype" :label="othertype">
						{{ $t('app_other') }}&nbsp;&nbsp;
						<el-input :disabled="$hwver.indexOf(uform.eqtype)!=-1" @input="otherInput" size="mini"
							v-model="othertype"></el-input>
					</el-radio>
				</el-form-item>
				<el-form-item :label="$t('app_upgrade_conditions')" :label-width="$formlbWidth" prop='condition'>
					<el-radio :key='index' v-for='(item,index) in $ugrdEvs' v-model="uform.condition" :label="item.vl">
						{{item.lb}}</el-radio>
				</el-form-item>
				<el-form-item :label="$t('app_file')" :label-width="$formlbWidth" prop=''>
					<el-upload class="upload-demo" ref="upload" name='file' :action="$msImportUrl()" :multiple='false'
						:before-upload='uploadBefore' :on-success="uploadSuccess" :on-change='uploadChange'
						:on-remove="onRemove" :limit="2" :show-file-list='true'>
						<el-button size="small" type="primary">{{ $t('app_clickUpdate') }}</el-button>

						<div slot="tip" class="el-upload__tip">{{uform.otaHost}}</div>
						<div v-if="ultmp.length == 2" slot="tip" class="el-upload__tip">{{ $t('app_file_error') }}</div>

						<!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
					</el-upload>
				</el-form-item>
				<el-form-item :label-width="$formlbWidth">
					<el-button @click="closeDia">{{ $t("app_cancel") }}</el-button>
					<el-button type="primary" @click="rqsBefore">{{ $t("app_sure") }}</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<EquipList :show='showdia1' :config='econfig'></EquipList>
	</div>
</template>

<style>

</style>

<script>
	import Pages from '@/components/Pages.vue'
	import EquipList from '@/components/EquipList.vue'
	import Merchant from '@/components/Merchant.vue'
	export default {
		data() {
			return {
				sortMc: {
					size: 'mini'
				},
				addMc: {
					size: ''
				},
				isdb: false,
				rules: {
					name: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					state: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					hver: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					aver: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					dbver: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					condition: [{
						required: true,
						message: this.$t("app_select"),
						trigger: 'blur'
					}],
					eqtype: [{
						required: true,
						message: this.$t("app_select"),
						trigger: 'blur'
					}]
				},
				isEdit: false,
				mcs: '',
				uid: '',
				usn: '',
				tempUgId: '',
				econfig: {},
				pconfig: '',
				tableData: [],
				showDia: false,
				showdia1: false,
				ultmp: [],
				othertype: '',
				uform: {
					id: '',
					name: '',
					state: '',
					hver: '',
					latWifiVerion: '',
					latGprsVerion: '',
					ag: '',
					gver1: '',
					aver: '',
					dbver: '',
					condition: '',
					eqtype: '',
					nwtype: '1',
					otaHost: '',
					otavl: ''
				},
				page: 1,
				total: 0,
				loading: false
			}
		},
		components: {
			Pages,
			EquipList,
			Merchant
		},
		computed: {
			addUgRqsDis() {
				var form = this.uform
				if (form.token && form.id && form.name && form.contact && form.phone) {
					return false
				} else {
					return true
				}
			}
		},
		methods: {
			rdchange(vl) {
				if (vl != this.uform.othertype) {
					this.othertype = ''
				}
			},
			otherInput(vl) {
				this.uform.eqtype = vl
			},
			initMc(mcvl) {
				var _this = this
				this.sortMc = {
					size: 'mini',
					value: mcvl,
					vlkey: 'clientKey',
					callback: (vl) => {
						// _this.tform.mech = vl?vl.toString():''  
						_this.mcs = vl ? vl : ''
						_this.getList()
					}
				}
			},
			initAddMc(mcvl) {
				var _this = this
				this.addMc = {
					isbc: false,
					value: parseInt(mcvl),
					vlkey: 'agentId',
					callback: (vl) => {
						_this.uform.ag = vl
					}
				}
			},
			uploadChange(file, fileList) {

			},
			onRemove(f, flist) {
				var arr = []
				var arr1 = []
				flist.forEach(item => {
					arr.push(item.response.data.url)
					arr1.push(item.response.data.checkValue)
				});
				this.uform.otaHost = arr.toString().replace(',', ';')
				this.uform.otavl = arr1.toString().replace(',', ';')

			},
			uploadSuccess(res, raw, flist) {
				this.ultmp = flist
				this.loading = false
				if (res.status == 200) {
					this.$message.success(res.message)
					var arr = []
					var arr1 = []
					flist.forEach(item => {
						arr.push(item.response.data.url)
						arr1.push(item.response.data.checkValue)
					});
					this.uform.otaHost = arr.toString().replace(',', ';')
					this.uform.otavl = arr1.toString().replace(',', ';')
				} else {
					this.$message.error(res.message)
				}
			},
			uploadBefore(file) {

			},
			indexget() {
				this.page = 1
				this.getList()
			},
			bindRqs(did, flag) {
				this.$upgradeBind(this.tempUgId, did, flag, res => {
					if (res.status == 200) {
						this.getList()
						this.showdia1 = false
						this.$message.success(res.message)
					} else if (res.status == 400 && res.data) {
						this.$confirm(res.message, this.$t('app_tip'), {
							confirmButtonText: this.$t('app_yes'),
							cancelButtonText: this.$t('app_no'),
							type: 'warning'
						}).then(() => {
							this.bindRqs(did, true)
						}).catch(() => {})
					} else {
						this.$message.error(res.message)
					}
				}, '')
			},
			bindAllRqs(eqtype, did, flag, agid) {
				var deviceId = ''
				var agentId = agid
				this.$ugBindAll(this.tempUgId, eqtype, deviceId, agentId, flag, res => {
					if (res.status == 200) {
						this.getList()
						this.showdia1 = false
						this.$message.success(res.message)
					} else if (res.status == 400 && res.data) {
						this.$confirm(res.message, this.$t('app_tip'), {
							confirmButtonText: this.$t('app_yes'),
							cancelButtonText: this.$t('app_no'),
							type: 'warning'
						}).then(() => {
							this.bindAllRqs(eqtype, did, true, agentId)
						}).catch(() => {})
					} else {
						this.$message.error(res.message)
					}
				}, '')
			},
			addTer(row) {
				this.setEconfig(row.upgradeType + '')
				this.tempUgId = row.id
				this.showdia1 = true
			},
			setCondition(row) {
				return this.$ugrdEv[row.condition]
			},
			setUpEuipType(row) {

			},
			rqsBefore() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.okDia()
					}
				})
			},
			okDia() {
				if (!this.isEdit) {
					this.addUgRqs()
				} else {
					this.upUgRqs()
				}
			},
			editRow(row) {
				this.isEdit = true
				this.showDia = true
				this.isdb = row.upgradeType == 3
				this.uform.dbver = row.gprssysver
				this.uform.name = row.name
				this.uform.state = row.info
				this.uform.hver = row.needhwver
				this.uform.gver1 = row.needgprsextver
				this.uform.aver = row.needusraudiover
				this.uform.condition = row.condition
				this.uform.id = row.id
				// this.uform.ag = row.agentId?row.agentId.split(','):[]
				this.uform.ag = row.agentId
				this.uform.otaHost = row.otahost
				this.uform.otavl = row.checkValue
				this.uform.latWifiVerion = row.latWifiVerion
				this.uform.latGprsVerion = row.latGprsVerion
				this.uform.eqtype = row.upgradeType + ''
				this.uform.nwtype = row.networkType + ''
				if (this.uform.eqtype != this.$evWifi && this.uform.eqtype != this.$evGPRSWifi && this.uform.eqtype != this
					.$ev4G) {
					this.othertype = this.uform.eqtype
				}
				this.initAddMc(this.uform.ag)
			},
			upUgRqs() {
				this.loading = true
				var form = this.uform
				this.$editUpgrade(form.id, form.name, form.state, form.gver1, form.condition, form.hver, form.aver, form
					.eqtype, form.otaHost, form.dbver, form.otavl, form.ag, form.nwtype, form.latWifiVerion, form
					.latGprsVerion, res => {
						this.loading = false
						if (res.status == 200) {
							this.closeDia()
							this.getList()
						} else {
							this.$message.error(res.message)
						}
					}, () => {
						this.loading = false
					})
			},
			delRqs(id) {
				this.loading = true
				this.$delUpgrade(id, res => {
					this.loading = false
					if (res.status == 200) {
						this.getList()
					} else {
						this.$message.error(res.message)
					}
				}, '')
			},
			// batchDel () {
			//   var arr = []
			//   this.sRows.forEach(item => {
			//     arr.push(item.id)
			//   })
			//   this.delRow(arr.toString())
			// },
			delRow(aid) {
				this.$showMsgBox(this.$t('app_delete_question'), () => {
					this.delRqs(aid)
				}, '')
			},
			rowClick(row, column) {
				if (column.label != this.$t('app_operation')) {
					this.toDetail(row)
				}
			},
			closeDia() {
				this.showDia = false
				this.isdb = false
				this.uform = {
					id: '',
					name: '',
					state: '',
					hver: '',
					latWifiVerion: '',
					latGprsVerion: '',
					ag: '',
					aver: '',
					dbver: '',
					eqtype: '',
					nwtype: '1',
					condition: '',
					otaHost: '',
					otavl: ''
				}
				this.rfForm()
				this.ultmp = []
				this.othertype = ''
			},
			rfForm() {
				this.$refs.upload.clearFiles()
				this.$refs['ruleForm'].resetFields()
			},
			addUgRqs() {
				this.loading = true
				var form = this.uform
				this.$addUpgrade(form.name, form.state, form.gver1, form.condition, form.hver, form.aver, form.eqtype, form
					.otaHost, form.dbver, form.otavl, form.ag, form.nwtype, 0, '', form.latWifiVerion, form
					.latGprsVerion, res => {
						this.loading = false
						if (res.status == 200) {
							this.closeDia()
							// this.getList()
							this.toDetail({
								id: res.data
							})
						} else {
							this.$message.error(res.message)
						}
					}, () => {
						this.loading = false
					})
			},
			addUg() {
				this.isEdit = false
				this.showDia = true
				this.initAddMc('')
			},
			addUg1() {
				this.isdb = true
				// this.uform.eqtype = 3
				this.addUg()
			},
			toDetail(row) {
				this.$router.push({
					path: '/upgrade/detail/',
					query: {
						id: row.id
					}
				})
			},
			getList() {
				this.loading = true
				var uid = this.uid ? this.uid : ''
				var usn = this.usn
				this.$upgradeList(this.page, this.$gRow, uid, usn, this.mcs, res => {
					this.loading = false
					if (res.status == 200) {
						// this.total = res.total
						this.total = res.total
						this.tableData = res.data
						//console.log("upgarade " + JSON.stringify(res.data))
					} else {
						this.$message.error(res.message)
					}
				}, '')
			},
			// batchSelected (val) {
			//   this.sRows = val
			// }
			setEconfig(eqtype) {
				var _this = this
				this.econfig = {
					type: 2, ////// 0商户 1渠道商 2升级
					eqtype: eqtype,
					bindall: (eqtype, did, mcvl) => {
						this.bindAllRqs(eqtype, did, false, mcvl)
					},
					callback: ids => {
						if (ids) {
							_this.bindRqs(ids, false)
						} else {
							this.showdia1 = false
						}
					}
				}
			}
		},
		mounted() {
			this.initMc('')
			this.getList()
			var _this = this
			this.pconfig = {
				callback: page => {
					///
					_this.page = page
					_this.getList()
				}
			}

		}
	}
</script>
